import { Templates } from '@hellohair/types';
import { MenuItem } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NextQuestionSelect, SearchIdSelect, StepField, StepSelect } from '../_shared/fields';
import { StepDialog, StepEditorProps } from '../_shared/StepDialog';
import { useStepDraft } from '../_shared/useStepDraft';

const TextAnswer: FC<StepEditorProps> = ({ survey, index, onClose }) => {
  const { t } = useTranslation();
  const { draft, set, save, dirty } = useStepDraft<Templates.StepDataText>(survey, index);

  return (
    <StepDialog
      survey={survey}
      index={index}
      onSave={save}
      onClose={onClose}
      dirty={dirty}
      edit={
        <>
          <StepField
            label={t('editor.field.question')}
            value={draft.question}
            onChange={(value) => set('question', value)}
            multiline
          />
          <StepField
            label={t('editor.field.tip')}
            value={draft.tip}
            onChange={(value) => set('tip', value)}
            multiline
          />
        </>
      }
      logic={
        <>
          <NextQuestionSelect
            steps={survey.steps}
            value={draft.followerId}
            onChange={(followerId) => set('followerId', followerId)}
          />
          <StepSelect
            label={t('editor.field.inputType')}
            value={draft.inputType ?? 'text'}
            onChange={(value) => set('inputType', value as Templates.StepDataText['inputType'])}
          >
            <MenuItem value="text">{t('editor.inputType.text')}</MenuItem>
            <MenuItem value="date">{t('editor.inputType.date')}</MenuItem>
          </StepSelect>
          <StepField
            label={t('editor.field.inputRegex')}
            value={draft.inputRegex}
            onChange={(value) => set('inputRegex', value)}
            helperText={t('editor.hint.inputRegex')}
          />
        </>
      }
      settings={
        <>
          <StepField
            label={t('editor.field.buttonLabel')}
            value={draft.next}
            onChange={(value) => set('next', value)}
          />
          <SearchIdSelect value={draft.searchID} onChange={(searchID) => set('searchID', searchID)} />
        </>
      }
    />
  );
};

export default TextAnswer;
